/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 2
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/lucaszerma/Localhost/events/defaultTrackers/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/lucaszerma/Localhost/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'localhost';

export const ApiKey: Record<Environment, string> = {
  localhost: '87b3d9754457ceef3126498ff11cf1d4'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '2',
    branch: 'defaultTrackers',
    source: 'web',
    versionId: '14760522-0656-4d54-8499-b8b8a2a4c553'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface LoginProperties {
  email: string;
  errorMessage: string;
}

export interface PageViewProperties {
  location: string;
}

export interface SearchProperties {
  document: string;
  /**
   * search used for document
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  types: string[];
}

export class Login implements BaseEvent {
  event_type = 'Login';

  constructor(
    public event_properties: LoginProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PageView implements BaseEvent {
  event_type = 'PageView';

  constructor(
    public event_properties: PageViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Search implements BaseEvent {
  event_type = 'Search';

  constructor(
    public event_properties: SearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Login
   *
   * [View in Tracking Plan](https://data.amplitude.com/lucaszerma/Localhost/events/defaultTrackers/latest/Login)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. email)
   * @param options Amplitude event options.
   */
  login(
    properties: LoginProperties,
    options?: EventOptions,
  ) {
    return this.track(new Login(properties), options);
  }

  /**
   * PageView
   *
   * [View in Tracking Plan](https://data.amplitude.com/lucaszerma/Localhost/events/defaultTrackers/latest/PageView)
   *
   * Event to track when a user views a specific page on the website
   *
   * Owner: Lucas Zerma
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  pageView(
    properties: PageViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageView(properties), options);
  }

  /**
   * Search
   *
   * [View in Tracking Plan](https://data.amplitude.com/lucaszerma/Localhost/events/defaultTrackers/latest/Search)
   *
   * Event triggered when a user performs a search action within the platform
   *
   * @param properties The event's properties (e.g. document)
   * @param options Amplitude event options.
   */
  search(
    properties: SearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new Search(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
